import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const trackingStartRenderer = ({ changes: { tracking_url }, ...props }) => {
  return (
    <Spacer {...props}>
      {!!tracking_url && (
        <Text color="grey800" display="block">
          <a href={tracking_url} target="_blank" rel="noreferrer">
            Tracking page
          </a>
          to see driver's position on map
        </Text>
      )}
    </Spacer>
  );
};

export default trackingStartRenderer;
